import { createContext, useContext, useState, useCallback } from 'react';
import { translations as baseTranslations, defaultLanguage } from '../i18n';
import { trialEndTranslations } from './trialEndTranslations';
 
// MERGE: Bestehende Translations + TrialEnd Translations
const translations = {
  de: {
    ...baseTranslations.de,
    ...trialEndTranslations.de,
  },
  en: {
    ...baseTranslations.en,
    ...trialEndTranslations.en,
  },
};
 
const LanguageContext = createContext();
 
export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const stored = localStorage.getItem('app_language');
    if (stored && translations[stored]) return stored;
    // First visit: detect from browser. German variants stay DE, everything else → EN.
    try {
      const nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
      const detected = nav.startsWith('de') ? 'de' : 'en';
      if (translations[detected]) return detected;
    } catch (e) {
      // navigator not available (SSR etc.)
    }
    return defaultLanguage;
  });
 
  const t = translations[lang] || translations[defaultLanguage];
 
  const setLanguage = useCallback((newLang) => {
    if (translations[newLang]) {
      setLang(newLang);
      localStorage.setItem('app_language', newLang);
    }
  }, []);
 
  return (
    <LanguageContext.Provider value={{ lang, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
 
export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
 
export default LanguageContext;
 